/* eslint-disable camelcase */
import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';
import services from './remoteServices';
import {Product} from '../models/product';

export type ProductsParamsType = {
  ids: number[];
};

export type SinglesProductIdsParamsType = {
  page: number;
};

export type SinglesProductsResponseType = {
  current_page: number;
  total_pages: number;
  limit_value: number;
  offset_value: number;
  size: number;
  total_count: number;
  suggestion: any;
  results: number[];
};

export const productsApi = createApi({
  reducerPath: 'productsApi',
  baseQuery: fetchBaseQuery({baseUrl: services.products}),
  endpoints: builder => ({
    fetchProducts: builder.query<Product[], ProductsParamsType>({
      query: params => ({
        url: `/styles.json?ids=${params.ids.join(',')}`,
        headers: {
          'Content-Type': 'application/json'
        }
      })
    }),
    fetchSinglesProductIds: builder.query<
      SinglesProductsResponseType,
      SinglesProductIdsParamsType
    >({
      query: (params: SinglesProductIdsParamsType) => ({
        url: `/search.json?q=*&filter[min_order_qty][]=1&filter[individual_ship_eligible][]=true&filter[singles_enabled]=true&page=${params.page}&per_page=42`,
        headers: {
          'Content-Type': 'application/json'
        },
        providesTags: ['SinglesProducts']
      })
    })
  })
});

export const {
  useFetchProductsQuery,
  useLazyFetchProductsQuery,
  useFetchSinglesProductIdsQuery,
  useLazyFetchSinglesProductIdsQuery
} = productsApi;
